import { HLink } from "../../ui/form/HLink";
import {config} from "../../../config";

export default function Footer({ className }) {
    return (
        <footer className={`flex flex-col sm:flex-row justify-between items-start p-2 lg:p-4 shadow-sm space-y-8 sm:space-y-0 text-sm bg-light-11 text-light-1 ${className}`}>
            <div>
                <p>{config.contact.companyName}</p>
                <p>{config.contact.address1} {config.contact.address2}</p>
                <p>{config.contact.city}, {config.contact.state} {config.contact.zip}</p>
                <p>{config.contact.phone}</p>
                <p>{config.contact.email}</p>
                <p>v{config.version}</p>
            </div>

            <div className="flex flex-col sm:items-end">
                <HLink to="/" text="About Us" />
                <HLink to="/" text="Contact" />
                <HLink to="/" text="Site Map" />
                <HLink to="/" text="Privacy Policy" />
                <HLink to="/" text="Terms & Conditions" />
            </div>
        </footer>
    )
}
